import Layer from 'ol/layer/Layer.js';
import WebGLVectorLayerRenderer from 'ol/renderer/webgl/VectorLayer.js';

/**
 * @description This is a wrapper around WebGLVectorLayerRenderer to be used as a layer.
 * OpenLayers already provides WebGLVectorLayer, but when we tried switching to it we
 * started experiencing issues with shaders crashing in some systems. The issues might not
 * have been caused by WebGLVectorLayer, but for now we are keeping the wrapper as it does not
 * introduce any new issues and does not lack any features from the oficial layer implementation.
 */

// import WebGLVectorLayer from 'ol/layer/WebGLVector.js';
// export class WebGLLayer extends WebGLVectorLayer {}

export class WebGLLayer extends Layer {
  constructor(options: any) {
    super(options);
  }
  createRenderer() {
    // @ts-expect-error
    return new WebGLVectorLayerRenderer(this, {
      className: this.getClassName(),
      style: this.get('style'),
    });
  }
}
